import CoverRequestCard from './CoverRequestCard';

export default CoverRequestCard;
